import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { GooglePlacesService, CampusAddressService } from '../../providers';
import forEach from 'lodash-es/forEach';
import includes from 'lodash-es/includes';
import find from 'lodash-es/find';

@Component({
  selector: 'address-search',
  styleUrls: ['./address_search.scss'],
  templateUrl: './address_search.pug',
  encapsulation: ViewEncapsulation.None
})

export class AddressSearchComponent {
  search: string;
  emptySearch = false;
  suggestions: Array<string>;
  campusPredictions: Array<string>
  addressPredictions: Array<string>
  suggestedHalls: Array<Object>;

  constructor(private googlePlacesService: GooglePlacesService,
              private campusService: CampusAddressService,
              private toastr: ToastsManager,
              private router: Router) { }

  ngOnInit() {
    setTimeout(function() {
      $('.homepage-searchblock').addClass('to-show-up');
    }, 200);
    this.googlePlacesService.initService();
  }

  searchAutocomplete(query: string) {
    this.googlePlacesService.getPredictions({ input: query });
    this.showCampusPredictions(query);
    setTimeout(() => {
      this.showAddressPredictions();
      this.suggestions = this.campusPredictions.concat(this.addressPredictions);
    }, 200);
  }

  showAddressPredictions() {
    let predictions: Array<string> = [];
    forEach(this.googlePlacesService.predictions, (prediction: Object) => {
      predictions.push(prediction['description'])
    })
    this.addressPredictions = predictions;
  }

  showCampusPredictions(query: string) {
    let predictions: Array<string> = []
    this.campusService.autocompleteHalls(query).subscribe((data) => {
      this.suggestedHalls = data['addresses'];
      forEach(this.suggestedHalls, (hall: Object) => {
          let prediction = hall['address_name'] + ', ' + hall['campus_name'];
          predictions.push(prediction)
        })
    });
    this.campusPredictions = predictions;
  }

  campusSuggested(suggestion: string) {
    return includes(this.campusPredictions, suggestion);
  }

  searchType() {
    if(this.campusSuggested(this.search)) {
      return 'campus'
    } else {
      return 'address'
    }
  }

  getHallId() {
    if( this.searchType() == 'campus') {
      let search = this.search.split(', ');
      let hall_name = search[0];
      let campus_name = search[1];
      return find(this.suggestedHalls, { 'address_name': hall_name, 'campus_name': campus_name })['id'];
    };
  }

  submitSearch() {
    if (this.search && this.search !== '') {
      let searchObject = JSON.stringify({ query: this.search,
                                          type: this.searchType(),
                                          hall_id:  this.getHallId()})
      window.localStorage.setItem('currentAddress', searchObject);
      this.router.navigate(['./results']);
    } else {
      this.toastr.info('Address is missing.');
      this.emptySearch = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/address_search/address_search.ts